import { type Order } from './types'

import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

function isNumeric(value: unknown): boolean {
  if (value === null || value === undefined || value === '') return false
  const num = Number(value)

  return !isNaN(num) && isFinite(num)
}

export function descendingComparator(a: CardActivityWithId, b: CardActivityWithId, orderBy: keyof CardActivityWithId) {
  const aValue = a[orderBy]
  const bValue = b[orderBy]

  // Handle null/undefined values
  if (!aValue && !bValue) return 0
  if (!aValue) return 1
  if (!bValue) return -1

  // Handle numeric comparison
  if (isNumeric(aValue) && isNumeric(bValue)) {
    const aNum = Number(aValue)
    const bNum = Number(bValue)

    if (bNum < aNum) return -1
    if (bNum > aNum) return 1

    return 0
  }

  // Handle string comparison
  const aStr = String(aValue).toLowerCase()
  const bStr = String(bValue).toLowerCase()

  if (bStr < aStr) return -1
  if (bStr > aStr) return 1

  return 0
}

export function getComparator(order: Order, orderBy: keyof CardActivityWithId) {
  return order === 'desc'
    ? (a: CardActivityWithId, b: CardActivityWithId) => descendingComparator(a, b, orderBy)
    : (a: CardActivityWithId, b: CardActivityWithId) => -descendingComparator(a, b, orderBy)
}
